import styled, { keyframes } from 'styled-components'

import { useGame } from '../context'

const StyledWordInfo = styled.div`
  width: 100%;
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const StyledWordInfoAbs = styled.div`
  pointer-events: none;
  user-select: none;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  z-index: 3;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const CurrentWord = styled.h2`
  margin: 0;
  padding: 0;
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  font-weight: 700;
`

const goodAnimation = keyframes`
    from {transform: translateY(1.25rem); opacity: 0}
    to {transform: translateY(0); opacity: 1}
`

const badAnimation = keyframes`
    0% {transform: translateX(0)}
    10% {transform: translateX(-0.5rem)}
    30% {transform: translateX(0.25rem)}
    50% {transform: translateX(-0.125rem)}
    70% {transform: translateX(0.0625rem)}
    90% {transform: translateX(-0.03125rem)}
    100% {transform: translateX(0)}
`

const InfoChip = styled.div`
  color: white;
  font-size: clamp(0.65rem, 3vw, 1.125rem);
  font-weight: 400;
  padding: 0.25rem 1rem;
  width: fit-content;
  height: fit-content;
  border-radius: 20rem;
  position: relative;
  &.error {
    background-color: #de3d2a;
    animation: ${badAnimation} 0.6s ease-in-out;
  }
  &.warning {
    background-color: #ebac00;
    animation: ${badAnimation} 0.6s ease-in-out;
  }
  &.success {
    background-color: #49b84f;
    animation: ${goodAnimation} 0.75s cubic-bezier(0, 0.75, 0.25, 1);
  }
`

const WordInfo = () => {
  const { currentWord, wordInfo } = useGame()

  let infoClass = ''
  switch (wordInfo) {
    case 'Palavra muito pequena':
      infoClass = 'error'
      break
    case 'Não é uma palavra desse jogo':
      infoClass = 'error'
      break
    case 'Já achou essa palavra':
      infoClass = 'warning'
      break
    default:
      infoClass = 'success'
      break
  }

  return (
    <>
      <div className="hidden md:flex w-full">
        <StyledWordInfo>
          {currentWord.length > 0 && <CurrentWord>{currentWord}</CurrentWord>}
          {wordInfo !== null && currentWord.length === 0 && (
            <InfoChip className={infoClass}>{wordInfo}</InfoChip>
          )}
        </StyledWordInfo>
      </div>
      <div className="md:hidden">
        <StyledWordInfoAbs>
          {wordInfo !== null && currentWord.length === 0 && (
            <InfoChip className={infoClass}>{wordInfo}</InfoChip>
          )}
        </StyledWordInfoAbs>
      </div>
    </>
  )
}

export default WordInfo
